import { listStyles } from "@insite/content-library/Widgets/ProductList/ProductListCardList";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

listStyles.wrapper = {
    css: css`
        margin-top: 20px;
        border: 1px solid ${getColor("common.border")};
    `,
};

listStyles.cardContainerStyles = {
    cardDivider: {
        css: css`
            width: 100%;
            margin: 0 !important;
            border-bottom: 1px solid ${getColor("common.border")};
        `,
    },
    gridItem: {
        css: css`
            margin: 0 10px !important;
        `,
    },
};
